import React, { useEffect, useState } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { useForm } from "react-hook-form";
import { useHistory, useParams } from 'react-router-dom';
// import useAuth from '../Login/useAuth';
import swal from 'sweetalert';

import { EmailOutlined, EmailRounded, HomeOutlined, InsertDriveFileOutlined, NfcOutlined, PhoneMissedOutlined } from '@material-ui/icons';
import Navigation from '../Navigation';
import useAuth from '../Login/useAuth';
const EmailUserupdate = () => {
    const { loading } = useAuth()

    const history = useHistory()
    const { emailId } = useParams()
    const [updateUser, setUpdateUser] = useState({})
    const { register, handleSubmit, formState: { errors } } = useForm();

    useEffect(() => {
        const url = `https://thawing-ridge-28572.herokuapp.com/single/${emailId}`
        fetch(url)
            .then(res => res.json())
            .then(data => {
                setUpdateUser(data)
            })
    }, [emailId])
    const onSubmit = data => {
        const url = `https://thawing-ridge-28572.herokuapp.com/single/${emailId}`
        fetch(url, {
            method: 'PUT',
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify(data)
        })
            .then(res => res.json())
            .then(data => {
                if (data.modifiedCount >= 0) {
                    swal('updated SuccessFully')

                    history.push('/adduser')
                }
            })
    }
    return (
        <>
            <Navigation></Navigation>
            {!loading &&
                <div className='shadow-sm p-3 mb-5 bg-body rounded'>

                    <form
                    
                    onSubmit={handleSubmit(onSubmit)}>
                        <Form 
                     data-aos="fade-up"
                     data-aos-duration="3000"
                        className='w-50 mx-auto text-start'>
                            {updateUser?.name && <Form.Group className="mb-3" >
                                <Form.Label >Your Name
                                    <InsertDriveFileOutlined className='text-success ms-2 fs-2'></InsertDriveFileOutlined>
                                </Form.Label>
                                <Form.Control readOnly defaultValue={updateUser?.name} {...register("name")} placeholder="Enter Name" />
                            </Form.Group>}
                            {updateUser?.email && <Form.Group className="mb-3" >
                                <Form.Label>Email address
                                    <EmailOutlined className='text-success ms-2 fs-2'></EmailOutlined>

                                </Form.Label>
                                <Form.Control readOnly defaultValue={updateUser?.email}  {...register("email")} placeholder="Enter email" />
                            </Form.Group>}
                            {updateUser?.number && <Form.Group className="mb-3" >
                                <Form.Label>PHone Number
                                    <PhoneMissedOutlined className='text-success ms-2 fs-2'></PhoneMissedOutlined>

                                </Form.Label>
                                <Form.Control defaultValue={updateUser?.number} {...register("number")} placeholder=" Enter number" />
                            </Form.Group>}
                            {updateUser?.address && <Form.Group className="mb-3" >
                                <Form.Label>Address
                                    <HomeOutlined className='text-success ms-2 fs-2'></HomeOutlined>

                                </Form.Label>
                                <Form.Control defaultValue={updateUser?.address} {...register("address",)} placeholder="Enter Address" />
                            </Form.Group>}
                            {updateUser?.relegion && <Form.Group className="mb-3" >
                                <Form.Label>Profession
                                    <NfcOutlined className='text-success ms-2 fs-2'></NfcOutlined>

                                </Form.Label>
                                <Form.Control defaultValue={updateUser?.relegion} {...register("relegion",)} placeholder="Enter Relegion" />
                            </Form.Group>}
                        </Form>
                        {errors.exampleRequired && <span>This field is required</span>}

                        <input className='btn btn-success ' type="submit" />
                    </form>
                </div>
            }
            {loading && <div>
                <div class="spinner-grow text-dark" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div><div class="spinner-grow text-dark" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
            </div>}
        </>
    );
};

export default EmailUserupdate;


